import React, { useEffect } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { navigate } from 'gatsby'
import Link from '../Link'
import { useLocation } from '@reach/router'

import * as styles from './index.module.css'

const Error404 = ({ subtitle, images }) => {
  const location = useLocation()

  useEffect(() => {
    // Return 404 if we are already on the correct locale
    if (
      location.pathname.indexOf('/jp/404/') !== -1 ||
      location.pathname.indexOf('/zh-cn/404/') !== -1
    ) {
      return
    }
    // Return Chinese 404
    if (location.pathname.indexOf('/zh-cn/') !== -1) {
      navigate('/zh-cn/404/')
    }
    // Return Japanese 404
    if (location.pathname.indexOf('/jp/') !== -1) {
      navigate('/jp/404/')
    }
  }, [location.pathname])

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <span>4</span>
        <GatsbyImage
          image={images[0].gatsbyImageData}
          className={styles.errorPuppy}
          alt="error-puppy"
        />
        <span>4</span>
      </div>
      <div className={styles.description}>
        <div className={styles.main}>
          {subtitle.subtitle.split('\n')[0]}
          <div>
            <Link to={'/'}>{subtitle.subtitle.split('\n')[1]}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error404
